// src/components/DiffTestComponent.js
import React from "react";
import EnhancedMergelyDiff from "./EnhancedMergelyDiff";
import "../DiffTestComponent.css"; // Adjust path if needed

const DiffTestComponent = ({ isOpen, onClose, json1, json2 }) => {
  if (!isOpen) return null;
  
  return (
    <div className="comparison-popup-overlay">
      <div className="comparison-popup-container">
        <div className="popup-header">
          <span className="popup-title">JSON Comparison</span>
          <button onClick={onClose} className="close-button">
            Close
          </button>
        </div>
        <EnhancedMergelyDiff lhs={json1} rhs={json2} />
      </div>
    </div>
  );
};

export default DiffTestComponent;